// @flow
import * as React from 'react';
import Icon from '../../../../components/shared/Icons/Icon';
import styles from './styles';

type Props = {
  verticalName: VerticalName,
  style: ?Object,
};

function SnippetPicturePlaceholder({ verticalName, style }: Props) {
  return (
    <span className="placeholder">
      <span>
        <Icon style={style} width={50} type={verticalName} />
      </span>
      <style jsx>{styles}</style>
    </span>
  );
}

SnippetPicturePlaceholder.defaultProps = {
  style: null,
};

export default SnippetPicturePlaceholder;



// WEBPACK FOOTER //
// ./app/common/Snippet/shared/SnippetPicturePlaceholder/component.js